<template>
	<div class="comp-record-sd-fans">
		<div class="comp-record-sdf-items">
			<div class="comp-record-sdf-item" v-for="fans in fansList" @click="fansClick(fans)">
				<div class="comp-record-sdf-avatar">
					<img :src="fans.wx_photo" alt="">
				</div>
				<div class="comp-record-sdf-info">
					<div class="comp-record-sdf-name">{{fans.wx_name}}</div>
					<div class="comp-record-sdf-desc">{{fans.msg_totle}}条相关聊天记录</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getFansListByRecord} from '../../network/local/search.js'
	
	export default{
		name:"ChatRecodSearchFansComp",
		props:{
			keyword:{
				type: String,
				default: ''
			}
		},
		data(){
			return {
				fansList:[]
			}
		},
		methods:{
			// 获取包含此聊天记录的粉丝列表，群列表
			getList(key){
				if(key === ''){
					this.fansList = []
					this.$emit('chat-record-search-fans-call',{type:'count',num:0})
					return
				}
				getFansListByRecord(key,data=>{
					this.fansList = data
					this.$emit('chat-record-search-fans-call',{type:'count',num:this.fansList.length})
				})
			},
			
			// 列表点击
			fansClick(fans){
				this.$emit('chat-record-search-fans-call',{type:'fans',fans:JSON.parse(JSON.stringify(fans))})
			}
		},
		watch:{
			keyword(nVal){
				this.getList(nVal)
			}
		}
	}
</script>

<style>
	.comp-record-sd-fans{
		width: 220px;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow-x: hidden;
		overflow-y: auto;
		border-right: 1px solid #e4e4e4;;
	}
	.comp-record-sd-fans .comp-record-sdf-items{
		width: 100%;
		height: auto;
		user-select: none;
	}
	.comp-record-sdf-items .comp-record-sdf-item{
		height: 40px;
		padding: 10px 10px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-bottom: 1px solid #e4e4e4;
		cursor: pointer;
	}
	.comp-record-sdf-item:hover{
		background-color: #e4e4e4;
	}
	.comp-record-sdf-item:last-child{
		border-bottom: none;
	}
	.comp-record-sdf-item .comp-record-sdf-avatar{
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}
	.comp-record-sdf-avatar img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.comp-record-sdf-item .comp-record-sdf-info{
		flex-grow: 1;
		width: 0;
		line-height: 20px;
		font-size: 12px;
		color: #353535;
	}
	.comp-record-sdf-info > div{
		height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.comp-record-sdf-info .comp-record-sdf-desc{
		color: #999999;
	}
</style>
